/* Sereolys magnesium advertorial-page kit: reveal PageFly content, route every link
 * to the magnesium product, and ONE sticky CTA that appears on scroll -> product. */
(function () {
  'use strict';
  var MAG = '/products/magnesium';

  function reveal() {
    document.querySelectorAll('.__pf [data-pf-type], .__pf .pf-animated, .__pf [class*="animat"]').forEach(function (el) {
      el.style.opacity = '1'; el.style.visibility = 'visible'; el.style.transform = 'none';
    });
  }

  function wireLinks() {
    document.querySelectorAll('.__pf a').forEach(function (a) {
      if (a.__mg) return; a.__mg = 1;
      var h = a.getAttribute('href') || '';
      if (/^(mailto:|tel:)/i.test(h)) return;
      a.setAttribute('href', MAG);
    });
  }

  var st = null, shown = null;
  function buildSticky() {
    if (document.getElementById('mg-sticky')) return;
    st = document.createElement('a'); st.id = 'mg-sticky'; st.href = MAG;
    st.textContent = 'SOULAGEMENT IMMÉDIAT →';
    st.style.cssText = 'position:fixed;left:50%;transform:translateX(-50%);bottom:16px;z-index:99990;' +
      'display:none;align-items:center;justify-content:center;box-sizing:border-box;' +
      'width:calc(100% - 32px);max-width:520px;padding:16px 22px;border-radius:10px;' +
      'background:#12305c;color:#fff;font:800 15px/1 Montserrat,"Poppins",Arial,sans-serif;' +
      'letter-spacing:.02em;text-align:center;text-decoration:none;box-shadow:0 8px 26px rgba(0,0,0,.28);';
    document.body.appendChild(st);
  }
  function checkSticky() {
    if (!st) return;
    var v = window.scrollY > 600;
    if (v === shown) return; shown = v;
    st.style.setProperty('display', v ? 'flex' : 'none', 'important');
  }

  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function countdown() {
    var d = document.getElementById('cd-days'), h = document.getElementById('cd-hrs'),
        m = document.getElementById('cd-min'), s = document.getElementById('cd-sec');
    if (!d || !h || !m || !s) return;
    var KEY = 'mg-cd-end', now = Date.now(), end = 0;
    try { end = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
    if (!end || end <= now) { end = now + 24 * 3600 * 1000; try { localStorage.setItem(KEY, String(end)); } catch (e) {} }
    function tick() {
      var r = Math.floor((end - Date.now()) / 1000);
      if (r <= 0) { end = Date.now() + 24 * 3600 * 1000; try { localStorage.setItem(KEY, String(end)); } catch (e) {} r = 24 * 3600; }
      d.textContent = pad(Math.floor(r / 86400));
      h.textContent = pad(Math.floor((r % 86400) / 3600));
      m.textContent = pad(Math.floor((r % 3600) / 60));
      s.textContent = pad(r % 60);
    }
    tick();
    if (!window.__mgCdTimer) { window.__mgCdTimer = setInterval(tick, 1000); }
  }

  function init() { reveal(); wireLinks(); buildSticky(); checkSticky(); countdown(); }
  if (document.readyState !== 'loading') init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 500); setTimeout(init, 1500);
  window.addEventListener('scroll', checkSticky, { passive: true });
  setInterval(checkSticky, 400);
})();
